import React from "react";
import {
    ACCESS_LEVEL,
    DEFAULT_DEBOUNCE_TIMEOUT,
    DEFAULT_PAGE,
    DEFAULT_FETCHED_OPTIONS,
} from "consts";
import { getProjects } from "api";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const ProjectAutoSuggest = (props) => (
    <AutoSuggest
        label="Project"
        fetchOptions={(q) => props.onDataFetch(q)}
        renderOption={(project) => ({
            label: `${project.Key} - ${project.Name}`,
            value: project,
        })}
        optionIdentifier={(project) => project.Id}
        debounceTimeout={DEFAULT_DEBOUNCE_TIMEOUT}
        {...props}
    />
);

ProjectAutoSuggest.defaultProps = {
    onDataFetch: (q) =>
        getProjects(q, ACCESS_LEVEL.USER, null, DEFAULT_PAGE, DEFAULT_FETCHED_OPTIONS, null, null, true)
            .then(value => value.content)
};

export default ProjectAutoSuggest;
